module.exports = __webpack_public_path__ + "static/media/landing_devices.9b60ec1a.png";